import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Div = styled(Box)`
  .title {
    color: var(--black, #000);
    text-align: center;
    font-family: Roboto;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 42px;
    letter-spacing: 0.25px;
  }
  .recover-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .back-to-login {
    color: var(--black, #000);
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-decoration-line: underline;
    text-transform: initial;

    margin-top: 20px;
  }
`;

export const DivHeader = styled(Box)`
  align-items: center;
  width: 540px;
  display: flex;
  height: 4.62rem;
  justify-content: center;
  position: relative;
  top: -16px;

  .header {
    position: fixed;
  }

  .logo {
    position: fixed;
  }
`;
